import { SubscriptionData } from 'src/utilities/types';

export enum SubscriptionStatus {
  NEW = 'NEW',
  EXISTING = 'EXISTING',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
}

const activeSubscriptionStatuses: SubscriptionStatus[] = [
  SubscriptionStatus.EXISTING,
  SubscriptionStatus.CANCELLED,
];

const expiredSubscriptionStatuses: SubscriptionStatus[] = [
  SubscriptionStatus.EXPIRED,
];

export class Subscription {
  constructor(private apiData?: SubscriptionData) {}

  public isActive(): boolean {
    return activeSubscriptionStatuses.includes(this.getStatus());
  }

  public isExpired(): boolean {
    return expiredSubscriptionStatuses.includes(this.getStatus());
  }

  private getStatus(): SubscriptionStatus {
    return this.getResponseData().status as SubscriptionStatus;
  }

  private getResponseData(): SubscriptionData {
    return this.apiData || ({} as SubscriptionData);
  }
}
